export default "__VITE_ASSET__3fec26c1__"